import { useEffect, useState } from 'react';

import { Flex, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { authApi } from '@/api';
import Redirector from '@/components/RRedirector';

const { Success } = Redirector;

const Reactivation: React.FC = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const { token } = useParams<{ token: string }>();

  useEffect(() => {
    const reactivateOrganization = async () => {
      try {
        if (token) {
          await authApi.reactivateOrganization(token);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    reactivateOrganization();
  }, [token]);

  if (isLoading) {
    return (
      <Flex justify="center" align="center" style={{ height: '90vh' }}>
        <Spin size="large" />
      </Flex>
    );
  }

  return (
    <Redirector redirectPath="/login">
      <Success
        title={t('reactivation.title')}
        description={t('reactivation.description')}
      />
    </Redirector>
  );
};
export default Reactivation;
